/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylesouth3Inputs */



/**
* | output |
* | --- |
* | "Self-Roaster" |
*
* @param {Personalityhumorstylesouth3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylesouth3 = /** @type {((inputs?: Personalityhumorstylesouth3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylesouth3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Self-Roaster")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autoironista")
	return /** @type {LocalizedString} */ ("Самоиронщик")
});
export { personalityhumorstylesouth3 as "personalityHumorStyleSouth" }